import React, { Component } from 'react';
import axios from 'axios';
import Swal from "sweetalert2/dist/sweetalert2";

import MenuList from '../Menu';
import LanguageInputs from "./LanguageInputs";
import Portfolio from "./Portfolio";

import { language, menu } from "../../../Constants";

import './style.scss';

class Portfolio2 extends Component {
    constructor(props) {
        super(props);

        this.state = {
            portfolios: [],
            initialized: false,
            inputs: {
                enTitle: '',
                enDescription: '',
                enFeedback: '',
                enFeedback2: '',
                ruTitle: '',
                ruDescription: '',
                ruFeedback: '',
                ruFeedback2: '',
                armTitle: '',
                armDescription: '',
                armFeedback: '',
                armFeedback2: '',
            },
        };
    }

    componentDidMount() {
        axios.post('/api/check').then(async result => {
            if (result.data.message !== 'you Were authorized') {
                this.props.history.push('/admin');
                return;
            }
            this.setState({
                initialized: true,
            });
            document.title = menu[3].text;

            const { data: { result: portfolios }, status } = await axios.post('/api/portfolio2/getAll');
            if (status) {
                this.setState({
                    portfolios,
                    initialized: true,
                });
            }
        }).catch(res => {
            if (res) {
                this.props.history.push('/admin');
            }
        })
    }

    handleChange = e => {
        const { value, name } = e.target;
        this.setState(prevState => ({
            ...prevState,
            inputs: {
                ...prevState.inputs,
                [name]: value,
            },
        }))
    };

    deletePortfolio = id => {
        let { portfolios } = this.state;
        portfolios = portfolios.filter(({ portfolio2id }) => portfolio2id !== id);

        this.setState({ portfolios });
    };

    updPortfolio = newP2 => {
        let { portfolios } = this.state;
        let index = portfolios.findIndex(({ portfolio2id }) => portfolio2id === newP2.id);

        portfolios[index] = newP2;
        this.setState({ portfolios });
    };

    addPortfolio = async e => {
        e.preventDefault();
        const { inputs } = this.state;
        let formData = new FormData(), err = false;

        Object.keys(inputs).forEach(key => {
            let value = inputs[key].trim();
            if (key.indexOf('Feedback') === -1 && !value) {
                err = true;
                return;
            }
            formData.append(key, value);
        });

        if (err) {
            Swal.fire({
                type: 'error',
                title: 'Կիսատ ինֆորմացիա',
                text: 'Լրացրեք բոլոր աստղանիշով դաշտերը',
            });
            return;
        }

        const { data, status } = await axios.post('/api/portfolio2/add', formData);

        if (status === 200) {
            const { inputs, portfolios } = this.state;
            const newP2 = {
                portfolioId: data.id,
                data: ['en', 'ru', 'arm'].map(lang => ({
                    lang,
                    title: inputs[lang + 'Title'],
                    text: inputs[lang + 'Description'],
                    feedback: inputs[lang + 'Feedback'],
                    feedback2: inputs[lang + 'Feedback2'],
                }))
            } ;
            portfolios.push(newP2);

            this.setState({
                inputs: {
                    enTitle: '',
                    enDescription: '',
                    enFeedback: '',
                    enFeedback2: '',
                    ruTitle: '',
                    ruDescription: '',
                    ruFeedback: '',
                    ruFeedback2: '',
                    armTitle: '',
                    armDescription: '',
                    armFeedback: '',
                    armFeedback2: '',
                },
                portfolios,
            })
        }
    };

    render() {
        if (!this.state.initialized) return null;

        return (
            <div id="portfolio2Page">
                <MenuList history={this.props.history} />
                <div id="right">
                    <header><h1>{menu[3].text}</h1></header>
                    <div>
                        <h3><em>Ավելացնել պորտֆոլիո</em></h3>
                        <form onSubmit={this.addPortfolio}>
                            <div id="formRight">
                              {language.map((lang, i) => (
                                <LanguageInputs
                                    key={i}
                                    {...lang}
                                    handleChange={this.handleChange}
                                    values={this.state.inputs}
                                />
                              ))}
                            </div>
                            <div id="formSubmit"><button>Ավելացնել</button></div>
                        </form>
                    </div>
                    <div>
                        <h3><em>Մեր պորտֆոլիոները 2</em></h3>
                        <div className="portfolios">
                            {this.state.portfolios.map((portfolio, i) => (
                                <Portfolio
                                    key={portfolio.portfolio2id + '' + i}
                                    change={this.updPortfolio}
                                    delP2={this.deletePortfolio}
                                    {...portfolio}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Portfolio2;
